(ns machtfit.startpage.navigation
  (:require [machtfit.app.routes :as routes]
            [machtfit.startpage.statics :as statics]
            [machtfit.startpage.subs :as subs]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(defn- menu-item [{:keys [filter-preset external-page text]}]
  (let [navigation-attrs (if external-page
                           (let [{:keys [url target]} (get statics/external-pages external-page)]
                             {:href @(rf/subscribe [:get [:urls url]])
                              :target target})
                           (routes/attrs-link-to-page {:id :catalog
                                                       :filter (get-in statics/filter-presets [filter-preset :filter])}))

        is-active? (and filter-preset
                        (= filter-preset @(rf/subscribe [:get [:ui :filter-preset]]))
                        (= :catalog @(rf/subscribe [:get [:ui :page :id]])))
        title (t text)]
    [:div
     [:a (merge {:class (when is-active?
                          "active")
                 :name title
                 :data-ph-capture-attribute-ui_id (str "header__main-nav-link__" (name (or filter-preset external-page :_)))}
                navigation-attrs)
      title]]))

(defn navigation []
  (let [{:keys [has-company-area?
                authenticated?
                is-employee?]} @(rf/subscribe [:get [:user]])
        show-marketplace? @(rf/subscribe [::subs/show-marketplace?])]
    (when (and authenticated?
               is-employee?)
      [:nav.new-nav
       {:data-ph-capture-attribute-ui_id "header__main-nav"}
       (when show-marketplace?
         [menu-item {:popover-id :machtfit-area
                     :filter-preset (when has-company-area?
                                      :machtfit-area)
                     :text {:de "Angebote"
                            :en "Offers"}}])

       [menu-item {:popover-id :magazine
                   :external-page :magazine
                   :text {:de "Magazin"
                          :en "Magazine"}}]

       (when has-company-area?
         [menu-item {:popover-id :company-area
                     :filter-preset (when show-marketplace?
                                      :company-area)
                     :text @(rf/subscribe [:get [:ui :company-area-name]])}])
       (when-let [wellhub-shortcut-url @(rf/subscribe [:get [:user :wellhub-shortcut-url]])]
         [:a.wellhub-link
          (assoc (routes/href-to-attrs wellhub-shortcut-url)
                 :data-ph-capture-attribute-ui_id "header__wellhub_button")
          [t {:de "Mit Wellhub trainieren"
              :en "Train with Wellhub"}]])])))
